module.exports = __webpack_public_path__ + "static/media/Avenir-Black.7466e8cc.ttf";